import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuth: false,
    User: undefined
  },
  reducers: {
    setAuth: (state, action) => {

      let isAuth = false;

      if (action.payload && action.payload._id
        && action.payload.isValid && !action.payload.isLocked
        && action.payload.isActive)
        isAuth = true;

      state.isAuth = isAuth;
      state.User = action.payload;

    },
    resetAuth: (state, action) => {
      state.isAuth = true;
      state.User = undefined
    }
  }
});

export const { setAuth, resetAuth } = authSlice.actions;

export const getAuth = state => state.auth;

export const checkAccess = (_access) => state => {

  let access = {
    canRead: false,
    canWrite: false
  };

  if (state.auth.User && state.auth.User.role){
    if (state.auth.User.role.isAdmin){
      access.canRead = true;
      access.canWrite = true;
    }

  }

  return access;
};

export default authSlice.reducer;
